import React from "react";
import "./Footer.scss";
import { AppWrapper, MotionWrap } from "../../Wrapper";

const Footer = () => {
  return (
    <>
      <h2 className="head-text">Connect On fiverr</h2>
      <div
        itemScope
        itemType="http://schema.org/Person"
        className="fiverr-seller-widget"
        style={{ display: "inline-block", marginTop: "30px" }}
      >
        <a
          itemProp="url"
          href="https://www.fiverr.com/nazmuln7"
          rel="noreferrer"
          target="_blank"
          className="fiverr_link"
          style={{
            display: "flex",
            maxWidth: "600px",
            gap: "20px",
          }}
        >
          <div
            className="fiverr-seller-content"
            id="fiverr-seller-widget-content-e62d2ed3-00c4-4bea-9f65-2ae861e3a1f9"
            itemProp="contentURL"
            style={{ display: "inline-block" }}
          ></div>
          <div
            id="fiverr-widget-seller-data"
            style={{
              display: "inline-block",
              marginTop: "10px",
              textAlign: "start",
            }}
          >
            <div
              itemProp="name"
              style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}
            >
              nazmuln7
            </div>
            <div itemScope itemType="http://schema.org/Organization">
              <span
                itemProp="name"
                style={{ color: "#00b12b", fontSize: "17px" }}
              >
                Fiverr
              </span>
            </div>
            <div
              itemProp="jobtitle"
              style={{ color: "gray", marginBottom: "5px" }}
            >
              Seller
            </div>
            <div itemProp="description" style={{ color: "gray" }}>
              Hello, I am Nazmul. I've always been fascinated with computers and
              technology, which encourage me to pursue professional development.
              My passion spurred my desire to work hard. Please do not hesitate
              to contact me if you require a comprehensive professional service.
              I'm prepared to apply my skills to your project. Thank You Nazmul
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default AppWrapper(
  MotionWrap(Footer, "app__footer"),
  "fiverr",
  "app__whitebg"
);
